


































































































import { Vue, Component, Prop } from "vue-property-decorator";

// Enums
import { ProductTypes } from "@/data/enums/products";

// Types
import { IProductCategory } from "@/models/products";

@Component({
  components: {
    "category-provider": () =>
      import(
        "@/components/app/admin/catalogue/categories/categoryProvider.vue"
      ),
    "category-image-carousel": () =>
      import(
        "@/components/app/admin/catalogue/categories/categoryImageCarousel.vue"
      ),
    "catalogue-breadcrumbs": () =>
      import(
        "@/components/app/admin/catalogue/products/productCatalogueBreadcrumbs.vue"
      )
  }
})
export default class CategoryView extends Vue {
  // Props

  @Prop({ required: true })
  public categoryId!: IProductCategory["id"];

  @Prop({ required: true })
  public productTypes!: ProductTypes[];

  // Computed

  public get routes(): any[] {
    return this.$_.get(this, "$attrs.routes", () => [])(this);
  }

  public get canShowProvisioning() {
    return this.$store.getters["org/hasProvisioningEnabled"];
  }
}
